import { useFeatureFlag } from "@repo/lib/hooks/common";
import { useCallback } from "react";

const useUserAttributes = () => {
  const isWebEngageEnabled = useFeatureFlag("webEngage");
  const handleSetUserAttributes = useCallback(
    async (session) => {
      if (!isWebEngageEnabled) {
        console.warn("WebEngage feature is disabled");
        return;
      }
      const { email, name, lastName, phoneNumber } = session?.user || {};
      if (window.webengage) {
        window.webengage.user.setAttribute("we_email", email);
        window.webengage.user.setAttribute("we_first_name", name);
        window.webengage.user.setAttribute("we_last_name", lastName);
        window.webengage.user.setAttribute("we_phone", phoneNumber);
      } else {
        console.error("WebEngage is not defined");
      }
    },
    [isWebEngageEnabled]
  );

  return { handleSetUserAttributes };
};

export default useUserAttributes;
